// haptic feedback not supported on web, so we need to create a dummy function to prevent warnings or errors

// Mock HapticFeedbackTypes for web compatibility
export enum HapticFeedbackTypes {
    selection = 'selection',
    impactLight = 'impactLight',
    impactMedium = 'impactMedium',
    impactHeavy = 'impactHeavy',
    rigid = 'rigid',
    soft = 'soft',
    notificationSuccess = 'notificationSuccess',
    notificationWarning = 'notificationWarning',
    notificationError = 'notificationError',
    clockTick = 'clockTick',
    contextClick = 'contextClick',
    keyboardPress = 'keyboardPress',
    keyboardRelease = 'keyboardRelease',
    keyboardTap = 'keyboardTap',
    longPress = 'longPress',
    textHandleMove = 'textHandleMove',
    virtualKey = 'virtualKey',
    virtualKeyRelease = 'virtualKeyRelease',
    effectClick = 'effectClick',
    effectDoubleClick = 'effectDoubleClick',
    effectHeavyClick = 'effectHeavyClick',
    effectTick = 'effectTick',
}

export const triggerHapticFeedback = (_method?: HapticFeedbackTypes) => {};
